/**
 * @fileoverview Picker Component
 * @author Lisa Liu (lliu@yext.com)
 */
goog.declareModuleId('yext.ui.components.picker');

import {GRAY3, WHITE} from '/ui/colors/colors';
import {DeprecatedOldButton as Button} from '/ui/components/button/button';
import {SearchBar} from '/ui/components/searchbar/searchbar';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/picker/picker.module.scss';

/**
* @param {{displayCart?: boolean,
*          onApply?: (function():void),
*          onCancel?: (function():void),
*          onSearch?: (function((string|undefined)):void),
*          searchPlaceholder?: string,
*          searchTerm?: string,
*          selectedSection?: React.ReactNode,
 *         selectFromSection?: React.ReactNode,
 *         smallFont?: boolean,
 *         fullStoryId?: string}} props
* @returns {React.ReactElement}
*/
export function Picker({
  displayCart = true,
  onApply = () => {},
  onCancel = () => {},
  onSearch = term => {},
  searchPlaceholder = '',
  searchTerm = '',
  selectedSection,
  selectFromSection,
  smallFont,
  fullStoryId,
}) {
  const buttonCssClass = (searchTerm && searchTerm.length > 0) ? 'picker-clear-search' : 'picker-clear-search picker-search__cleared';

  return (
    <div>
      {selectedSection && selectedSection}
      <SearchBar searchTerm={searchTerm} onSearch={onSearch} placeholder={searchPlaceholder}/>
      {selectFromSection}
      {displayCart
        && <div
          style={{
            height: '50px',
            backgroundColor: WHITE,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            borderTop: '1px solid ' + GRAY3,
          }}
          className={smallFont ? styles.cartSmallFont : ''}>
          <Button chromeless={true} onClick={onCancel}>
            {yext.msg('Cancel')}
          </Button>
          <Button context="primary" onClick={onApply} margin="10px" fullStoryId={fullStoryId}>
            {yext.msg('Apply')}
          </Button>
        </div>
      }
    </div>
  );
}
